const events = [];

const $scroll = function(dom, fn, sn) {
  let newScroll = { dom, fn, sn}
  events.push(newScroll);
  fn._index = events.length - 1;
  // console.log(events, "events");
};

$scroll.remove = function(dom) {
  events.forEach((item,key)=> {
    if (item.dom === dom) {
      events.splice(key, 1)
    }
  })
  // console.log(events, "d-events")

  // fn._index && events.splice(fn._index, 1);
};

// 函数节流
function throttle(fn,wait){
  let pre = Date.now();
  return function(){
      let context = this;
      let args = arguments;
      let now = Date.now();
      if( now - pre >= wait){
          fn.apply(context,args);
          pre = Date.now();
      }
  }
}

//上拉加载；
const Scroll = {
  addHandler: function(element, type, handler) {
    if (element.addEventListener)
      element.addEventListener(type, throttle(handler,100), false);
    else if (element.attachEvent) element.attachEvent("on" + type, throttle(handler,100));
    else element["on" + type] = handler;
  },
  listenTouchDirection: function() {
    this.addHandler(window, "scroll", function() {
      const wh = window.innerHeight,
        st = window.scrollY;
      let obj = {
        scrollY: st,
        innerHeight: wh
      };
      events
        .filter(e => e.dom.scrollHeight && e.dom.scrollHeight > 0)
        .forEach(e => {
          var dh = e.dom.scrollHeight;
          var s = Math.ceil((st / (dh - wh)) * 100);
          if (s > 85) e.fn();
          if (e.sn) e.sn(obj);
        });
    });
  }
};

Scroll.listenTouchDirection();

export default $scroll;
export { Scroll };
